import { cn } from '@/lib/utils'
import { getInitials } from './-formatters'

function ProductMonogram({ name }: { name?: string | null }) {
  return (
    <div
      className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border border-border/60 bg-background/40 font-semibold text-foreground"
      aria-hidden="true"
    >
      {getInitials(name)}
    </div>
  )
}

export function CustomerMonogram({
  name,
  toneKey,
  size = 'default',
}: {
  name?: string | null
  toneKey?: number | string | null
  size?: 'default' | 'sm'
}) {
  const tones = [
    'bg-chart-5/15 text-foreground',
    'bg-chart-3/15 text-foreground',
    'bg-chart-2/15 text-foreground',
    'bg-chart-1/15 text-foreground',
  ]
  const normalizedToneIndex =
    typeof toneKey === 'number'
      ? Math.abs(toneKey)
      : Array.from(String(toneKey ?? name ?? '')).reduce(
          (sum, character) => sum + character.charCodeAt(0),
          0
        )
  const sizeClass = size === 'sm' ? 'h-8 w-8 text-xs' : 'h-11 w-11 text-base'

  return (
    <div
      className={cn(
        'flex shrink-0 items-center justify-center rounded-full border border-border/60 font-semibold',
        sizeClass,
        tones[normalizedToneIndex % tones.length]
      )}
      aria-hidden="true"
    >
      {getInitials(name)}
    </div>
  )
}

export function ProductThumbnail({ imageUrl, name }: { imageUrl?: string | null; name?: string }) {
  if (!imageUrl) {
    return <ProductMonogram name={name} />
  }

  return (
    <div className="h-10 w-10 shrink-0 overflow-hidden rounded-xl border border-border/60 bg-background/40">
      <img src={imageUrl} alt={name} className="h-full w-full object-cover" loading="lazy" />
    </div>
  )
}
